import { aC as a, aO as o } from "./StickyHeaderSkeleton-f12bcf9d.mjs";
import { s as n, A as e } from "./Header-490425af.mjs";
function y(r) {
  const {
    lang: s
  } = a();
  return n({
    url: o(e.CLIENT_V1_MY_CATEGORY),
    queryKey: [e.CLIENT_V1_MY_CATEGORY, {
      lang: s
    }],
    options: {
      suspense: !1,
      useErrorBoundary: !1,
      ...r
    }
  });
}
export {
  y as u
};
